import { http, httpgst } from '../../main'
import { store } from '../../store'

const actions = {
  getUsers ({commit, dispatch}, payload) {
    let url = 'api/user'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetUser', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getAreas ({commit, dispatch}, payload) {
    let url = 'api/areas'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetAreas', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getValidators ({commit, dispatch}, payload) {
    let url = 'api/validators'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetValidators', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({commit, dispatch}, payload) {
    let url = 'api/validators'
    let params = {
      'user_id': payload.event.item.user_id,
      // 'gst_area_id': payload.event.item.gst_area_id,
      'areas': payload.event.areas,
      'status': 1
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put ({commit, dispatch}, payload) {
    let url = 'api/validators/' + payload.event.item.id
    let params = {
      'user_id': payload.event.item.user_id,
      'gst_area_id': payload.event.item.gst_area_id,
      'status': 1
    }
    // if (payload.event.item.user_id === payload.event.context.originalItem.user_id) {
    //   params.user_id = undefined
    // }
    if (payload.event.item.gst_area_id === payload.event.context.originalItem.gst_area_id) {
      params.gst_area_id = undefined
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete ({commit, dispatch}, payload) {
    let url = 'api/validators/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getValidatorsByCompany ({commit, dispatch}, payload) {
    let url = 'api/validators-by-company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetValidatorsCompany', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  onGetUser (state, payload) {
    let users = payload.response.data.data
    payload.event.context.users = users
  },
  onGetAreas (state, payload) {
    let areas = payload.response.data.data
    payload.event.context.areas = areas
  },
  onGetValidators (state, payload) {
    let validators = payload.response.data.data
    if (payload.event.context.validatorsRequest) {
      payload.event.context.validatorsRequest = validators
    } else {
      payload.event.context.validators = validators
      payload.event.context.loadingItems = false
    }
  },
  onPost (state, payload) {
    payload.event.context.refresh()
    payload.event.context.loading = false
    let errors = payload.response.data.data.errors
    let message = payload.response.data.message + '<br>'
    if (errors) {
      if (errors.duplicated.msg !== '') {
        message += `<li>${errors.duplicated.msg}</li>`
      }
      if (errors.insertError.msg !== '') {
        message += `<li>${errors.insertError.msg}</li>`
      }
      if (errors.noCompanyArea.msg !== '') {
        message += `<li>${errors.noCompanyArea.msg}</li>`
      }
      if (errors.noItem.msg !== '') {
        message += `<li>${errors.noItem.msg}</li>`
      }
      payload.event.context.showNotification(message, 'error', -1)
    } else {
      payload.event.context.showNotification(payload.response, 'success')
    }
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onPut (state, payload) {
    let validator = payload.response.data.data
    validator.user_id = validator.user_id
    validator.gst_area_id = validator.gst_area_id
    validator.status = validator.status
    let validators = payload.event.context.validators
    validators.splice(payload.event.index, 1, validator)
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  onDelete (state, payload) {
    let validators = payload.event.context.validators
    validators.splice(payload.event.index, 1)
    payload.event.context.showNotification(payload.response, 'success')
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  },
  onGetValidatorsCompany (state, payload) {
    let validators = payload.response.data.data
    if (payload.event.context.validatorsRequest) {
      payload.event.context.validatorsRequest = validators
    } else {
      payload.event.context.validators = validators
      payload.event.context.loadingItems = false
    }
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/validators.js